import { gql } from '@apollo/client';
import { Fragments } from 'api/fragments';

export const GET_CONFIG_FILES = gql`
  query getConfigurationFiles {
    configFiles {
      name
      id
      readOnly
    }
  }
`;

export const ADD_CONFIG_FILE = gql`
  mutation addConfigurationFile($name: String!) {
    addConfigFile(name: $name) {
      ...ConfigurationFile
    }
  }
  ${Fragments.ConfigurationFile}
`;

export const DELETE_CONFIG_FILE = gql`
  mutation deleteConfigurationFile($id: ID!) {
    deleteConfigFile(id: $id) {
      id
    }
  }
`;
